import React from 'react'
import styled from '@emotion/styled'
import {keyframes} from '@emotion/react'
import Modal from '../../../shared/Modal'
import {theme} from '../../../theme'

const spin = keyframes`
  to { transform: rotate(360deg); }
`
const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.space[4]};
  padding: ${theme.space[4]} 0;
`
const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${theme.colors.border.default};
  border-top-color: ${theme.colors.text.link};
  border-radius: 50%;
  animation: ${spin} 0.75s linear infinite;
`
const Label = styled.p`
  margin: 0;
  font-size: ${theme.fontSizes.base};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.text.primary};
`
const SubLabel = styled.p`
  margin: 0;
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.secondary};
`

// "Generating link…" modal shared by the Keap Partner link flows (1:Many and
// the Account Setup payment-details step). Not dismissable — it stays up until
// the caller flips `isOpen` off.
export function GeneratingLinkModal({isOpen}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      size="sm"
      showCloseButton={false}
      closeOnBackdrop={false}
      closeOnEsc={false}
      headerDivider={false}
    >
      <Body>
        <Spinner />
        <Label>Generating link…</Label>
        <SubLabel>This may take a few moments</SubLabel>
      </Body>
    </Modal>
  )
}
